import { useEffect } from 'react';

// Adds scroll-reveal animation to key layout blocks.
// Respects prefers-reduced-motion via the CSS (.reveal rules are
// only defined inside the no-preference media query).
const REVEAL_SELECTORS = [
  '.section-heading',
  '.pitch-grid',
  '.service-grid',
  '.feature-grid',
  '.use-case-grid',
  '.pricing-grid',
  '.engagement-grid',
  '.methodology-steps',
  '.stats-grid',
  '.founders-grid',
  '.spectrum-grid',
  '.story .container',
].join(', ');

export default function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(REVEAL_SELECTORS);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    els.forEach((el) => {
      el.classList.add('reveal');
      // Index each child so CSS can stagger any number of items.
      Array.from(el.children).forEach((child, i) => {
        child.style.setProperty('--i', String(i));
      });
      observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);
}
